var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg12IconFeatherIconsHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2E3A59",
    strokeWidth: 1.333
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.6L8 0l8 5.6v8.8c0 .884-.796 1.6-1.778 1.6H1.778C.796 16 0 15.284 0 14.4V5.6z",
    transform: "translate(-31.000000, -78.000000) translate(24.000000, 65.055709) translate(8.000000, 14.500000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.333 16L5.333 8 10.667 8 10.667 16",
    transform: "translate(-31.000000, -78.000000) translate(24.000000, 65.055709) translate(8.000000, 14.500000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12IconFeatherIconsHome);
export default __webpack_public_path__ + "static/media/1-2-icon-feather-icons-home.7188abe6.svg";
export { ForwardRef as ReactComponent };